<template>
  <div class="product">
      <!-- 第一部分 -->
      <div class="product_1 pd_b20">
        <div class="product_1_content">
          <p class="title product_1_title color_fff txt_c">产品和服务</p>
        </div>
      </div>
      <!-- 第二部分 -->
      <div class="product_2 pd_b20">
        <div class="pt50 pb50">
          <p class="title color_333 txt_c">产品</p>
          <div class="clear_fd mt50">
            <div class="ft_l product_2_cp" style="width:32%">
              <img src="../assets/product/product_cp_1.png" alt="">
              <div class="product_2_cp_content color_fff">
                <p class="product_2_cp_content_title">充电站代运维</p>
                <p class="product_2_cp_content_content mt15">确保您的充电站安全、经济运行</p>
                <p class="product_2_cp_content_content">-充电服务</p>
                <p class="product_2_cp_content_content">-紧急抢修</p>
                <p class="product_2_cp_content_content">-日常维护</p>
                <p class="product_2_cp_content_content">-定期维护</p>
                <p class="product_2_cp_content_content">-设备技术改造</p>
                <p class="product_2_cp_content_content">-平台维护升级</p>
              </div>
            </div>
            <div class="ft_l product_2_cp" style="width:32%;margin-left:2%;">
              <img src="../assets/product/product_cp_2.png" alt="">
              <div class="product_2_cp_content color_fff">
                <p class="product_2_cp_content_title">充电站代建设</p>
                <p class="product_2_cp_content_content mt15">确保您的充电站经济、高效落地</p>
                <p class="product_2_cp_content_content">-综合高效评估</p>
                <p class="product_2_cp_content_content">-风险系统识别</p>
                <p class="product_2_cp_content_content">-系统设计</p>
                <p class="product_2_cp_content_content">-投资预算</p>
                <p class="product_2_cp_content_content">-安全验收</p>
                <p class="product_2_cp_content_content">-交付放心</p>
              </div>
            </div>
            <div class="ft_r product_2_cp" style="width:32%">
              <img src="../assets/product/product_cp_3.png" alt="">
              <div class="product_2_cp_content color_fff">
                <p class="product_2_cp_content_title">充电站投资建设</p>
                <p class="product_2_cp_content_content mt15">确保客户充电站安全、效益兼收</p>
                <p class="product_2_cp_content_content">-行业积累</p>
                <p class="product_2_cp_content_content">-运营经验</p>
                <p class="product_2_cp_content_content">-产业链融通</p>
                <p class="product_2_cp_content_content">-集成建设</p>
                <p class="product_2_cp_content_content">-客户精准服务</p>
                <p class="product_2_cp_content_content">-安全和效益</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三部分 -->
      <div class="product_3 pd_b20">
        <div>
          <p class="title color_333 txt_c pt50 pb50">服务</p>
          <div>
            <div class="clear_fd product_3_li">
              <div class="ft_l product_3_li_img mr45"><img src="../assets/product/product_fw_1.png" alt=""></div>
              <div class="ft_l product_3_li_content">
                <p class="product_3_li_content_1">联营站应急充电服务</p>
                <p class="product_3_li_content_2">量势新能源充分整合自有资源，包含充电桩产品/云平台/技术支持/运营和维护服务等，服务于符合量势联营充电运营商资质的合作伙伴，共同为最终集团用户企业提供日常运营、特殊时期和应急阶段等一揽子整体解决方案。</p>
              </div>
            </div>
             <div class="clear_fd product_3_li mt25">
              <div class="ft_l product_3_li_img mr45"><img src="../assets/product/product_fw_2.png" alt=""></div>
              <div class="ft_l product_3_li_content">
                <p class="product_3_li_content_1">充电运营效率提升服务</p>
                <p class="product_3_li_content_2">根据根据集团用户充电日常管理具体需要，协助企业用户诊断和优化充电服务管理环节，并且可二次迭代开发采集用户需求，分析并自动生成运营报表和财务结算报告，提升充电环节上下游作业的效率。</p>
              </div>
            </div>
             <div class="clear_fd product_3_li mt25">
              <div class="ft_l product_3_li_img mr45"><img src="../assets/product/product_fw_3.png" alt=""></div>
              <div class="ft_l product_3_li_content">
                <p class="product_3_li_content_1">车桩联调</p>
                <p class="product_3_li_content_2">通过新能源车辆导入初期，协助用户聚焦车桩测试联调。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// import axios from 'axios'
const axios = require("axios");
export default {
  data(){
    return {
      serverList: [
        {
          imgSrc: "../assets/product/product_fw_1.png",
          title:"联营站应急充电服务",
          content: "量势新能源充分整合自有资源，包含充电桩产品/云平台/技术支持/运营和维护服务等，服务于符合量势联营充电运营商资质的合作伙伴，共同为最终集团用户企业提供应急保姆式充电服务。"
        },
        {
          imgSrc: "../assets/product/product_fw_2.png",
          title: "充电运营效率提升服务",
          content: "根据根据集团用户充电日常管理具体需要，协助企业用户诊断和优化充电服务管理环节，并且可二次迭代开发采集用户需求，分析并自动生成运营报表和财务结算报告，提升充电环节上下游作业的效率。"
        },
        {
          imgSrc: "../assets/product/product_fw_3.png",
          title: "车桩联调",
          content: "通过新能源车辆导入初期，协助用户聚焦车桩测试联调。"
        }
      ]
    }
  }
};
</script>

<style>
.title {
  font-size: 34px;
  font-weight: bold;
}
/* 第一部分样式 */
.product_1 {
  height: 300px;
  background-image: url("../assets/product/product_bg_1.png");
  background-size: 100% 100%;
  position: relative;
}
.product_1::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.product_1_content {
  position: relative;
}
.product_1_title {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  top: 178px;
  z-index: 2;
}
/* 第二部分 */
.product_2_cp {
  position: relative;
}
.product_2_cp img {
  width: 100%;
}
.product_2_cp_content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 28px;
  background-color: rgba(0, 0, 0, 0.1);
}
.product_2_cp_content_title {
  font-size: 27px;
  font-weight: bold;
}
.product_2_cp_content_content {
  font-size: 17px;
}
/* 第三部分样式 */
.product_3 {
  height: 830px;
  background-image: url("../assets/product/product_bg_3.png");
  background-size: 100% 100%;
}
.product_3_li {
  border: 2px solid #eeeeee;
  box-sizing: border-box;
  padding: 37px 54px;
  background-color: #ffffff;
}
.product_3_li_img {
  width: 10%;
  margin-top: 15px;
}
.product_3_li_img img {
  width: 100%;
}
.product_3_li_content {
  width: 82%;
}
.product_3_li_content_1 {
  font-size: 27px;
  color: #333333;
}
.product_3_li_content_2 {
  font-size: 17px;
  color: #666666;
  margin-top: 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/productServer.vue